import { SELECT_COLUMN_DEFINITION_ITEM } from '@antimatterhq/ui/constants/table';
import { TableColumnDefinition } from '@antimatterhq/ui/types/TableColumnDefinition';

export function tableColumnDefinitionsWithResizingDisabled(
  columnDefinitions: TableColumnDefinition[],
) {
  return columnDefinitions.map((column) => ({
    ...column,
    enableResize: false,
  }));
}

export function tableColumnDefinitionsWithSelection(
  columnDefinitions: TableColumnDefinition[],
) {
  return [
    SELECT_COLUMN_DEFINITION_ITEM,
    ...columnDefinitions,
  ] as TableColumnDefinition[];
}

export function tableColumnDefinitionsWithTooltipDisabled(
  columnDefinitions: TableColumnDefinition[],
) {
  return columnDefinitions.map((column) => ({
    ...column,
    tooltip: false,
  }));
}

export function tableColumnDefinitionsWithFilteringDisabled(
  columnDefinitions: TableColumnDefinition[],
) {
  return columnDefinitions.map((column) => ({
    ...column,
    enableFiltering: false,
  }));
}

export function tableColumnDefinitionsWithSortingDisabled(
  columnDefinitions: TableColumnDefinition[],
) {
  return columnDefinitions.map((column) => ({
    ...column,
    enableSorting: false,
  }));
}
